import { ITake } from "@/types/ITake";
import { ITakeComment } from "@/types/ITakeComment";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TakesState {
  take: ITake;
  comments: ITakeComment[];
}

const initialState: TakesState = {
  take: {} as ITake,
  comments: [],
};

export const TakeDetailSlice = createSlice({
  name: "take_detail_slice",
  initialState,
  reducers: {
    setTakeObject: (state, action: PayloadAction<ITake>) => {
      state.take = action.payload;
      state.comments = [];
    },
    postMytakeAnsweronDetail: (
      state,
      action: PayloadAction<{ take_id: number; answer: number }>
    ) => {
      const { answer } = action.payload;
      if (state.take) {
        if (answer === 1) {
          state.take.answer1 += 1;
        } else {
          state.take.answer2 += 1;
        }
        state.take.myAnswer = 1;
      }
    },
    resolveTakeInRedux : (state) => {
      if (state.take) {
        state.take.prediction.prediction_closed = 1;
      }
    },
    setComments: (state, action: PayloadAction<ITakeComment[]>) => {
      state.comments = [...state.comments, ...action.payload];
    },
    submitComment: (
      state,
      action: PayloadAction<{ comment: ITakeComment; parentCommentId: number }>
    ) => {
      if (action.payload.parentCommentId === 0)
        state.comments = [action.payload.comment, ...state.comments];
      else {
        const parentComment = state.comments.find(
          (c) => c.id === action.payload.parentCommentId
        );
        if (parentComment) {
          parentComment.amountReplies += 1;
          parentComment.replies = [
            action.payload.comment,
            ...parentComment.replies,
          ];
        }
      }
      state.take.commentsAmount += 1;
    },
    likeUnlikeComment: (
      state,
      action: PayloadAction<{ commentId: number }>
    ) => {
      const { commentId } = action.payload;
      const comment = state.comments.find((c) => c.id === commentId);
      if (!comment) return;
      const like = comment.iLiked ? 0 : 1;
      if (comment) {
        comment.iLiked = like;
        comment.likes += like ? 1 : -1;
      }
    },
    likeUnlikeNestedComment: (
      state,
      action: PayloadAction<{ commentId: number; parentId: number }>
    ) => {
      const { commentId, parentId } = action.payload;
      const parentComment = state.comments.find((c) => c.id === parentId);
      if (!parentComment) return;
      const comment = parentComment.replies.find(
        (c: ITakeComment) => c.id === commentId
      );
      if (!comment) return;
      const like = comment.iLiked ? 0 : 1;
      if (comment) {
        comment.iLiked = like;
        comment.likes += like ? 1 : -1;
      }
    },
    reset: (state) => {
      state.take = {} as ITake;
      state.comments = [];
    },
  },
});

export const {
  setTakeObject,
  reset,
  postMytakeAnsweronDetail,
  setComments,
  submitComment,
  resolveTakeInRedux,
  likeUnlikeComment,
  likeUnlikeNestedComment,
} = TakeDetailSlice.actions;
export default TakeDetailSlice.reducer;
